import ComingSoonCard from '../components/ComingSoonCard'

export default function HomePage() {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] px-4 py-12">
      <ComingSoonCard />
    </div>
  )
}
